import { toColumnLetters } from '../../../utils/stringUtils';
import type { Chain } from './layout';
import type { EditorNode } from './types';

// Builds the visual instance labels for one intervention group: a number for
// each arranged instance in render order (chains top-to-bottom, each chain
// left-to-right, one continuous series) and a letter for each Flex-pool instance
// in pool order. Purely derived from the current layout; never persisted and
// never sent to the backend (see docs/adr/0001-instance-labels-visual-only-derived).
export function computeInstanceLabels(
  orderedChains: Chain[],
  free: EditorNode[]
): Map<string, string> {
  const labels = new Map<string, string>();

  let position = 1;
  for (const chain of orderedChains) {
    for (const item of chain.items) {
      labels.set(item.id, String(position));
      position += 1;
    }
  }

  free.forEach((node, index) => {
    labels.set(node.id, toColumnLetters(index + 1));
  });

  return labels;
}
